var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 11 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.708 9.16-8.067 7.566c-.389.365-1.02.365-1.408 0l-.941-.882a.894.894 0 0 1-.002-1.32L6.683 8.5.29 2.476a.894.894 0 0 1 .002-1.32l.94-.882a1.043 1.043 0 0 1 1.41 0l8.066 7.565c.39.365.39.957 0 1.322"
  })));
};
export default SvgChevron;